<template>
  <div class="col-12">
    <div class="row">
      <div class="col-6 pl-4">
        <label class="input-label titleRbtn">Por Estatus</label>
      </div>
      <div class="col-6 pl-4">
        <label class="input-label titleRbtn">Adicionales</label>
      </div>
    </div>
    <div class="row">
      <div class="col-6 pl-4">
        <!-- Default inline 1-->
        <div class="custom-control custom-radio pt-2">
          <input
            id="alertFilter0"
            v-model="selected"
            type="radio"
            name="alertFilter"
            checked
            value="0"
            :class="{ invalid: error }"
            class="custom-control-input"
            @input="onAlertSelectedFilter($event.target.value)"
          />
          <label
            class="custom-control-label fontrbtn"
            for="alertFilter0"
            :class="{ invalid: error }"
          >
            Estudiantes con Estatus Egresados y Referidos desde el estatus de
            vinculado
          </label>
        </div>
        <div class="custom-control custom-radio pt-2">
          <input
            id="alertFilter1"
            v-model="selected"
            type="radio"
            name="alertFilter"
            value="1"
            :class="{ invalid: error }"
            class="custom-control-input"
            @input="onAlertSelectedFilter($event.target.value)"
          />
          <label
            class="custom-control-label fontrbtn"
            for="alertFilter1"
            :class="{ invalid: error }"
          >
            Estatus de Vinculaciones Iniciales
          </label>
        </div>
        <Error v-if="error" variant="no-border" :message="customErrorMsg" />
      </div>
      <div class="col-6 pl-4">
        <!-- Default inline 1-->
        <div class="custom-control custom-radio pt-2">
          <input
            id="alertFilter2"
            v-model="selected"
            type="radio"
            name="alertFilter"
            value="2"
            :class="{ invalid: error }"
            class="custom-control-input"
            @input="onAlertSelectedFilter($event.target.value)"
          />
          <label
            class="custom-control-label fontrbtn"
            for="alertFilter2"
            :class="{ invalid: error }"
          >
            Referidos con cambios de Definición de Servicios
          </label>
        </div>
        <div class="custom-control custom-radio pt-2">
          <input
            id="alertFilter3"
            v-model="selected"
            type="radio"
            name="alertFilter"
            value="3"
            :class="{ invalid: error }"
            class="custom-control-input"
            @input="onAlertSelectedFilter($event.target.value)"
          />
          <label
            class="custom-control-label fontrbtn"
            for="alertFilter3"
            :class="{ invalid: error }"
          >
            Vencimiento de Admisión
          </label>
        </div>
        <div class="custom-control custom-radio pt-2">
          <input
            id="alertFilter4"
            v-model="selected"
            type="radio"
            name="alertFilter"
            value="4"
            :class="{ invalid: error }"
            class="custom-control-input"
            @input="onAlertSelectedFilter($event.target.value)"
          />
          <label
            class="custom-control-label fontrbtn"
            for="alertFilter4"
            :class="{ invalid: error }"
          >
            Vencimiento de Servicio
          </label>
        </div>
        <Error v-if="error" variant="no-border" :message="customErrorMsg" />
      </div>
    </div>
  </div>
</template>

<script>
import Error from '@/components/common/Error';

export default {
  name: 'RadioBtnGroup',
  data() {
    return {
      selected: '',
    };
  },
  meta: {
    description: 'Componente personalizado para manejo de referidos.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Error,
  },
  watch: {
    selectedValue(newVal, oldVal) {
      if (newVal != oldVal) {
        this.selected = newVal.thrpyReferralAlertTypes;
      }
    },
  },
  props: {
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
    selectedValue: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isValid() {
      return !this.error && this.dirty;
    },
  },
  methods: {
    onAlertSelectedFilter(value) {
      let filter = {
        thrpyReferralAlertTypes: value,
      };

      this.$emit('onAlertSelectedFilter', filter);
    },
  },
  mounted() {
    if (this.selectedValue) {
      this.selected = this.selectedValue.thrpyReferralAlertTypes;
    }
  },
};
</script>
<style scoped>
.custom-control-input,
.custom-control-label {
  cursor: pointer;
}
.custom-control-input:checked.custom-control-input:checked:disabled
  ~ .custom-control-label::before {
  color: #fff;
  border-color: #2db782;
  background-color: #2db782;
}
.custom-control-input.invalid ~ .custom-control-label::before {
  background-color: #f7d7da;
  border-color: #e85c5c;
}

.sucess-icon {
  font-size: 19px;
  position: absolute;
  top: 9px;
  right: 7px;
  color: #3f5b60;
  margin-right: 0.2rem;
}
.sucess-icon:before {
  content: '\f058';
  color: #2db782;
}
div.invalid:not(input) {
  color: #e85c5c;
}
.form-control-icon-normal {
  position: absolute;
  top: 9px;
  right: 10px;
  color: #3f5b60;
  margin-right: 0.2rem;
}
.icon-invalid {
  color: #e85c5c;
}

.custom-error i {
  float: left;
  margin-top: 15px;
  margin-right: 10px;
  color: #e85c5c;
}

.custom-control-label.invalid::before {
  border-color: #e85c5c;
  border-width: 2px;
  background: #f7d7da;
}

.titleRbtn {
  font: Bold 18px/21px Lato;
}
.fontrbtn {
  font-weight: 200;
}
</style>
